import React, { useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import { PasswordGate } from './components/PasswordGate';
import { ProjectSelector } from './components/ProjectSelector';
import { ProjectPasswordPrompt } from './components/ProjectPasswordPrompt';
import { ProjectWorkspace } from './components/ProjectWorkspace';
import { TopBar } from './components/TopBar';
import { projects } from './data/projects';
import { useSessionUnlock } from './hooks/useSessionUnlock';
import { useProjectAccess } from './hooks/useProjectAccess';
import { useTheme } from './contexts/ThemeContext';
import { brandVars, resolveBrand } from './utils/brandStyle';
export function App() {
  const {
    unlocked,
    ready,
    unlock,
    lock
  } = useSessionUnlock();
  const {
    hasAccess,
    grant,
    revokeAll
  } = useProjectAccess();
  const {
    theme
  } = useTheme();
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const selectedProject = projects.find(project => project.id === selectedId) ?? null;
  const projectUnlocked = selectedProject ? hasAccess(selectedProject.id) : false;
  function handleLock() {
    setSelectedId(null);
    revokeAll();
    lock();
  }
  if (!ready) {
    return <div className="min-h-screen w-full bg-shell-bg" aria-hidden="true" data-id="element-0" data-mp="3mj6jhwnqi0fz" />;
  }
  if (!unlocked) {
    return <PasswordGate onUnlock={unlock} data-id="element-1" data-mp="5yj0slx59ec" />;
  }
  if (selectedProject) {
    const brand = resolveBrand(selectedProject.brand, theme);
    return <div className="min-h-screen w-full" style={{
      ...brandVars(brand),
      backgroundColor: brand.bg,
      color: brand.text,
      fontFamily: brand.bodyFont
    }} data-id="element-2" data-mp="2zm4vedw4z0yn">
        <TopBar onLock={handleLock} onBack={() => setSelectedId(null)} brand={brand} data-id="element-3" data-mp="38kgk2adfzoog" />
        <AnimatePresence mode="wait" data-id="element-4" data-mp="3dmfprqwnmxok">
          {projectUnlocked ? <ProjectWorkspace key={selectedProject.id} project={selectedProject} brand={brand} data-id="element-5" data-mp="nwc0xqashrv7" /> : <ProjectPasswordPrompt key={`${selectedProject.id}-gate`} project={selectedProject} brand={brand} onUnlock={() => grant(selectedProject.id)} onCancel={() => setSelectedId(null)} data-id="element-6" data-mp="stkjhrzunxwz" />}
        </AnimatePresence>
      </div>;
  }
  return <div className="grid-noise min-h-screen w-full bg-shell-bg font-sans" data-id="element-7" data-mp="d2bibguajxvo">
      <TopBar onLock={handleLock} data-id="element-8" data-mp="8649ngaig8a1" />
      <ProjectSelector projects={projects} hasAccess={hasAccess} onSelect={setSelectedId} data-id="element-9" data-mp="3gle9ehqxh1en" />
    </div>;
}